import Component from 'vue-class-component';
import { mapState } from 'vuex';

import { DEVICE_TYPE } from '@/utils';

import Mixin from './mixin';

@Component({
  computed: {
    ...mapState('app', { device: 'device' }),
  },
})
export default class MixinDevice extends Mixin {
  device!: string;

  isMobile() {
    return this.device === DEVICE_TYPE.MOBILE;
  }

  isDesktop() {
    return this.device === DEVICE_TYPE.DESKTOP;
  }

  isTablet() {
    return this.device === DEVICE_TYPE.TABLET;
  }
}
